/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentScenarioControllerGetQueryResponse, IncidentScenarioControllerGetPathParams } from "../../models/incidentAgentController/IncidentScenarioControllerGet";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentScenarioControllerGet } from "../../clients/incident-agentService/incidentScenarioControllerGet";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentScenarioControllerGetQueryKey = (id: IncidentScenarioControllerGetPathParams["id"]) => [{
  url: '/api/v1/incident-agent/scenarios/:id',
  params: {
    id: id
  }
}] as const;
export type IncidentScenarioControllerGetQueryKey = ReturnType<typeof incidentScenarioControllerGetQueryKey>;
export function incidentScenarioControllerGetQueryOptions(id: IncidentScenarioControllerGetPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentScenarioControllerGetQueryKey(id);
  return queryOptions<IncidentScenarioControllerGetQueryResponse, ResponseErrorConfig<Error>, IncidentScenarioControllerGetQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentScenarioControllerGet(id, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/scenarios/:id}
 */
export function useIncidentScenarioControllerGet<TData = IncidentScenarioControllerGetQueryResponse, TQueryData = IncidentScenarioControllerGetQueryResponse, TQueryKey extends QueryKey = IncidentScenarioControllerGetQueryKey>(id: IncidentScenarioControllerGetPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<IncidentScenarioControllerGetQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentScenarioControllerGetQueryKey(id);
  const query = useQuery({
    ...incidentScenarioControllerGetQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}